function Error() {
  return (
    <section className="section">
      <div className="container has-text-centered box" id="error">
        <h2 className="title">hOops! Something went wrong!</h2>
      </div>
    </section>
  )
}

export default Error
